module.exports = "/images/menu-red.svg?b3342edaddbd64ce36796a6a5178844b";